import { render, staticRenderFns } from "./HuchaTotals.vue?vue&type=template&id=06cf028f&scoped=true"
import script from "./HuchaTotals.vue?vue&type=script&lang=js"
export * from "./HuchaTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf028f",
  null
  
)

export default component.exports